module.exports = __webpack_public_path__ + "6-o1.gif?011bfcb7f7da4b9da202747dd4990cc0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quiz/questions/6-o1.gif
// module id = 658
// module chunks = 0